import { Controller } from "stimulus"
import Velocity from "velocity-animate"

export default class extends Controller {
  static targets = [ "item" ]

  connect() {
    [].forEach.call(document.querySelectorAll('.accordion.is-active'), function(el) {
      var itemBody = el.querySelector('.accordion-body');
      itemBody.setAttribute('style', 'display: block;');
    })
  }

  toggle() {
    var item = event.target.closest('.accordion');
    var itemBody = item.querySelector('.accordion-body');
    if (item.classList.contains('is-active')) {
      var slideDir = 'slideUp';
      item.classList.remove("is-active");
    } else {
      var slideDir = 'slideDown';
      item.classList.add("is-active");
    }

    Velocity(itemBody, slideDir, {duration: 200, easing: 'ease-in-out' })
  }
}
